import {useFormContext, useWatch, useFieldArray} from 'react-hook-form'

import {
  OrderChangeConfigOptions,
  OrderChangeConfig,
  OrderChangeFieldSetting
} from '../types/OrderChangeConfig'

export const useChangeableFieldsSettings = (configOptions: OrderChangeConfigOptions) => {
  const {control} = useFormContext<OrderChangeConfig>()
  const countryCode = useWatch({control, name: 'countryCode'})
  const {fields, append, update, remove} = useFieldArray({
    control,
    name: 'changeableFields',
    keyName: '_id'
  })

  const availableFields = Object.keys(configOptions.availableFields).filter((key) =>
    configOptions.availableFields[key].allowedCountries.includes(countryCode)
  )

  const addField = (fieldName: string) => {
    append({
      fieldName,
      editLeadTime: 0,
      editLeadTimeUom: configOptions.leadTimeUnitOfMeasures[0],
      requestsPendingApprovalPermitted: false,
      orderChangeSettingId: ''
    })
  }

  const deleteField = (fieldName: string) => {
    const index = fields.findIndex((item) => item.fieldName === fieldName)
    if (index !== -1) {
      remove(index)
    }
  }

  const changeField = <K extends keyof Exclude<OrderChangeFieldSetting, 'fieldName'>>(
    fieldName: string,
    key: K,
    value: OrderChangeFieldSetting[K]
  ) => {
    const index = fields.findIndex((f) => f.fieldName === fieldName)
    if (index === -1) return

    const currentItem = fields[index]
    update(index, {
      ...currentItem,
      [key]: value
    })
  }

  return {
    fields,
    availableFields,
    addField,
    changeField,
    deleteField
  }
}
